import Vue from 'vue/dist/vue.esm.js';
import TurbolinksAdapter from 'vue-turbolinks'
import { inputChangeClass } from "../mixins/input_change_class";
import {globalMixin} from "../mixins/global";

Vue.use(TurbolinksAdapter)

document.addEventListener('turbolinks:load', () => {
  const element = document.getElementById("vue-lp-public_assistances-new") ||
    document.getElementById("vue-lp-public_assistances-create") ||
    document.getElementById("vue-lp-public_assistances-edit")
  if (element) {
    window.vueLoaded = true

    const app = new Vue({
      el: element,
      mixins: [inputChangeClass, globalMixin],
      components: {
      },
      data: () => {
        return {}
      },
      created() {
      },
      async mounted() {
      },
      methods: {
      }
    })
  }
})
